import { App } from 'vue';

import AppPage from '@/components/app-page';
import AddressPicker from '@/components/address-picker';
import Pagination from '@/components/pagination';
import Upload from '@/components/upload/index';
import InputNumber from '@/components/input-number';
import InputNumberRanger from '@/components/input-number-ranger';
import QuerySelect from '@/components/query-select';
import Empty from '@/components/empty';
import Editor from '@/components/editor';
import Tabs from '@/components/tabs';
import SearchArea from '@/components/search-area';
import HeaderArea from '@/components/header-area';
import DetailTitle from '@/components/detail-title';
import CustomLogs from '@/components/custom-logs';
import DictionarySelect from '@/components/dictionary-select';
import PageCard from '@/components/page-card';
import ConditionSelect from '@/components/condition-select';
import Uploader from '@/components/uploader/index';
import Uploader2 from '@/components/uploader2/index';
import CustomImage from '@/components/custom-image/index';

export default function componentsInstall(app: App) {
  app.use(Editor);
  app.use(AppPage);
  app.use(AddressPicker);
  app.use(Pagination);
  app.use(Upload);
  app.use(InputNumber);
  app.use(InputNumberRanger);
  app.use(QuerySelect);
  app.use(Empty);
  app.use(Tabs);
  app.use(SearchArea);
  app.use(HeaderArea);
  app.use(DetailTitle);
  app.use(CustomLogs);
  app.use(DictionarySelect);
  app.use(PageCard);
  app.use(ConditionSelect);
  app.use(Uploader);
  app.use(Uploader2);
  app.use(CustomImage);
}
